module.exports = __webpack_public_path__ + "img/fish-3.b75e124e.png";